import { NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatMenuItem } from '@angular/material/menu';
import { environment } from '../../../../../../../../environments/environment.prod';
import { CustomFlexLayoutModule } from '../../../../../../../flex-layout/custom-flex-layout.module';
import { DefaultLayoutDirective } from '../../../../../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../../../../../flex-layout/custom-layout-align';
import { DefaultLayoutGapDirective } from '../../../../../../../flex-layout/custom-layout-gap';
import { DefaultFlexDirective } from '../../../../../../../flex-layout/flex';
import { DefaultStyleDirective } from '../../../../../../../flex-layout/style';
import { CommonService } from '../../../../../../../services/common.service';
import { CharacterPipe } from '../../../../../../pipes/character.pipe';

@Component({
  selector: 'calsoft-nested-child',
  imports: [MatMenuItem, DefaultLayoutDirective, DefaultLayoutAlignDirective, CustomFlexLayoutModule, DefaultFlexDirective, NgStyle, DefaultStyleDirective, DefaultLayoutGapDirective, CharacterPipe],
  templateUrl: './nested-child.component.html',
  styleUrl: './nested-child.component.scss'
})
export class NestedChildComponent implements OnInit {
  public serverPath = environment.commonImageApi + 'category/image/150x150/';
  @Input() list: any;
  @Input() type: any;
  display: boolean |any;
  @Input() data: any;
  @Input() displayImageInMenu: any;

  @Input() submenu: any;
  
  constructor(private commonService: CommonService,) { }

  ngOnInit(): void {

    if (window.innerWidth < 1281) {
      this.display = false;
    }else{
      this.display=true
    }
    

  }

  goToCategory(menu:any) {

    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);

  }
}

